import "./list.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import Datatable from "../../components/datatable/Datatable"
import { useParams } from "react-router-dom";

const List = () => {
  const { type } = useParams();
  return (
    <div className="list">
      <Sidebar/>
      <div className="listContainer">
        <Navbar/>
        <Datatable title={type} type={type}/>
      </div>
    </div>
  )
}

export default List